import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Home, Products } from "../components/_landing"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <Home />
    <div id="productos" />
    <Products />
  </Layout>
)

export default IndexPage
